// The image an event shows in the app. The backend stores what the host
// entered: an Instagram post URL, a direct image URL or a data URL. The app
// resolves an Instagram post to its cover picture (instagram.com/p/<code>/
// media/?size=l); the backend does the same for the landing page and serves
// the result at /live-radar/instagram/<type>/<code>.jpg, cached and same
// origin. The dashboard uses that endpoint so the reviewer sees exactly the
// picture the app will show.

import { BASE_URL } from '../api/client';

export const instagramPostInfo = (url) => {
  if (!url || typeof url !== 'string') return null;
  try {
    const u = new URL(url.trim());
    const host = u.hostname.replace(/^www\./, '');
    if (host !== 'instagram.com') return null;
    const parts = u.pathname.split('/').filter(Boolean);
    if (parts.length < 2 || !['p', 'reel', 'tv'].includes(parts[0])) return null;
    if (!/^[A-Za-z0-9_-]+$/.test(parts[1])) return null;
    // a link to one picture of a carousel carries "?img_index=3" (1-based); 1 is the cover
    const imgIndex = Number(u.searchParams.get('img_index'));
    return { type: parts[0], code: parts[1], imgIndex: Number.isInteger(imgIndex) && imgIndex >= 2 ? imgIndex : 1 };
  } catch {
    return null;
  }
};

export const instagramThumbnailUrl = (url, apiBase = BASE_URL) => {
  const info = instagramPostInfo(url);
  if (!info) return '';
  const index = info.imgIndex > 1 ? `?img_index=${info.imgIndex}` : '';
  return `${String(apiBase).replace(/\/+$/, '')}/live-radar/instagram/${info.type}/${info.code}.jpg${index}`;
};

const looksLikeBase64 = (value) =>
  value.length > 100 && /^[A-Za-z0-9+/=\s]+$/.test(value);

/**
 * Turns the stored image value into something an <img> can load, or ''.
 */
export const eventImageSrc = (raw, apiBase = BASE_URL) => {
  if (raw == null) return '';
  const value = typeof raw === 'object' && 'present' in raw
    ? (raw.present ? raw.value : '')
    : raw;
  if (typeof value !== 'string') return '';
  const text = value.trim();
  if (!text) return '';
  if (text.startsWith('data:image/')) return text;
  if (/^https?:\/\//i.test(text)) return instagramThumbnailUrl(text, apiBase) || text;
  if (looksLikeBase64(text)) return `data:image/jpeg;base64,${text.replace(/\s+/g, '')}`;
  return '';
};
